__turbopack_context__.v({
  "company_location": "job-card-module__BkU9tW__company_location",
  "header": "job-card-module__BkU9tW__header",
  "job_card": "job-card-module__BkU9tW__job_card",
  "job_title": "job-card-module__BkU9tW__job_title",
});
